<template>
  <div class="modash-data-wrap">
    <div class="modash-search-form">
      <div class="modash-header-tabs" @click="tabs != 'instagram' ? changeTab('instagram') : ''" :class="tabs == 'instagram' ? 'active' : ''">Instagram</div>
      <div class="modash-header-tabs" @click="tabs != 'tiktok' ? changeTab('tiktok') : ''" :class="tabs == 'tiktok' ? 'active' : ''">TikTok</div>
      <div class="modash-header-tabs" @click="tabs != 'youtube' ? changeTab('youtube') : ''" :class="tabs == 'youtube' ? 'active' : ''">YouTube</div>
    </div>
    <div class="modash-data-form" v-show="tabs == 'instagram'" :class="tabs == 'instagram' ? 'active' : ''">
      <div class="wrap-title" style="margin-bottom:20px">Modashデータ登録(Instagram)</div>
      <div class="input-container">
        <div class="modash-data-title">JSON<span style="color:red">*</span></div>
        <div class="textarea-container">
          <textarea class="modash-data-textarea"
                    name="jsonParam"
                    v-model="modashJson"
                    ref="area"
                    :style="styles"
                    placeholder="Modashから取得したJSONを入力してください。"
          ></textarea>
          <div class="divider full" style="width: 80%; border-top: none">
            <div class="w-90 flex-row" style="justify-content:flex-end">
              <el-button type="primary" @click="modashJsonRegistry">登録</el-button>
              <el-button type="info" @click="clearTextarea">リセット</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modash-data-form" v-show="tabs == 'tiktok'" :class="tabs == 'tiktok' ? 'active' : ''">
      <div class="wrap-title" style="margin-bottom:20px">Modashデータ登録(TikTok)</div>
      <div class="input-container">
        <div class="modash-data-title">JSON<span style="color:red">*</span></div>
        <div class="textarea-container">
          <textarea class="modash-data-textarea"
                    name="jsonParam"
                    v-model="modashJson"
                    ref="area"
                    :style="styles"
                    placeholder="Modashから取得したJSONを入力してください。"
          ></textarea>
          <div class="divider full" style="width: 80%; border-top: none">
            <div class="w-90 flex-row" style="justify-content:flex-end">
              <el-button type="primary" @click="modashJsonRegistry">登録</el-button>
              <el-button type="info" @click="clearTextarea">リセット</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modash-data-form" v-show="tabs == 'youtube'" :class="tabs == 'youtube' ? 'active' : ''">
      <div class="wrap-title" style="margin-bottom:20px">Modashデータ登録(YouTube)</div>
      <div class="input-container">
        <div class="modash-data-title">JSON<span style="color:red">*</span></div>
        <div class="textarea-container">
          <textarea class="modash-data-textarea"
                    name="jsonParam"
                    v-model="modashJson"
                    ref="area"
                    :style="styles"
                    placeholder="Modashから取得したJSONを入力してください。"
          ></textarea>
          <div class="divider full" style="width: 80%; border-top: none">
            <div class="w-90 flex-row" style="justify-content:flex-end">
              <el-button type="primary" @click="modashJsonRegistry">登録</el-button>
              <el-button type="info" @click="clearTextarea">リセット</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const modashTiktokerJsonRegistryAPI = root + "/api/admin/modash_tiktoker_json_registry";
const modashInstagrammerJsonRegistryAPI = root + "/api/admin/modash_influencer_json_registry";
const modashYoutuberJsonRegistryAPI = root + "/api/admin/modash_youtuber_json_registry";
export default {
  data() {
    return {
      modashJson: '',
      height: "400px",
      tabs: "instagram",
    }
  },
  computed: {
    styles() {
      return {
        "height": this.height,
        "width": "80%",
        "resize": "none",
        "overflow-y": "auto",
      }
    },
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    modashJsonRegistry() {
      let params = new URLSearchParams();
      params.append("token", this.token);
      params.append("json_param", this.modashJson);
      let url = modashTiktokerJsonRegistryAPI;
      if (this.tabs == "instagram" ) {
        url = modashInstagrammerJsonRegistryAPI;
      } else if (this.tabs == "youtube") {
        url = modashYoutuberJsonRegistryAPI;
      }
      this.axios
          .post(url, params)
          .then((response) => {
            if (response.data.status === "OK") {
              this.$alert("登録が完了しました。", "Success", {});
            } else if (response.data.status === "NG") {
              this.$alert(response.data.message, "Error", {});
            }
          })
          .catch(() => {
            this.$alert("予期せぬ例外が発生しました。システムに問い合わせてください。", "Error", {});
          });
    },
    clearTextarea() {
      this.modashJson = '';
    },
    changeTab(tab) {
      this.loading = true;
      this.tabs = tab;
    },
  },
}
</script>